/**
 * Update decoder packages (activate/deactivate packs).
 */
export const updateDecoderPacks = async (payload) => {
  const response = await fetch(`/api/user/decoders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error("Failed to update decoder packs");
  return await response.json();
};

